import { render, staticRenderFns } from "./admin-shops.vue?vue&type=template&id=32645fe1&scoped=true&"
import script from "./admin-shops.vue?vue&type=script&lang=js&"
export * from "./admin-shops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32645fe1",
  null
  
)

export default component.exports